import {
  useStyle 
} from "@/classify"
import {
  Fragment 
} from "react"
import {
  FormattedDate 
} from "react-intl"
import defaultClasses from "./date.module.css"

const Date = (props) => {
  const classes = useStyle(defaultClasses, props.classes)
  const {
    attribute_metadata = {}, entered_attribute_value = {} 
  } = props

  const attributeLabel = attribute_metadata.label ? (
    <div className={classes.label}>{attribute_metadata.label}</div>
  ) : null
  let attributeContent

  // TODO: Get correct data from GraphQl based on config time zone
  if (entered_attribute_value.value) {
    // Convert date to ISO-8601 format so Safari can also parse it
    const isoFormattedDate = entered_attribute_value.value.replace(" ", "T")

    attributeContent = (
      <div className={classes.content}>
        <FormattedDate
          value={isoFormattedDate}
          year='numeric'
          month='short'
          day='2-digit'
        />
      </div>
    )
  }

  return (
    <Fragment>
      {attributeLabel}
      {attributeContent}
    </Fragment>
  )
}

export default Date
